import { SettingsSectionCard } from "./SettingsSectionCard";
import { useFormikContext } from "formik";
import { SimpleClusterForm } from "@/types";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import { TextField } from "@/components/forms/fields";
import {
  required,
  validateContainerImage,
  validateContainerImageMetachar
} from "@/components/forms/validation";
import { containerVerticalFlowAnalytics } from "../analytics";
import { SectionHeader } from "@/components/Common/SectionHeader/SectionHeader";

export const ContainerImageSection: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<SimpleClusterForm>();
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-row flex-wrap items-center justify-between">
        <SectionHeader
          title="Add Container Image"
          subtitle="Public or Private docker image to deploy."
          savedInConfig
        />
        <Select
          value={values.isPrivate ? "private" : "public"}
          onValueChange={(v) => {
            setFieldValue("isPrivate", v === "private");
            containerVerticalFlowAnalytics.trackContainerImageSelected(v as "public" | "private");
          }}
        >
          <SelectTrigger className="h-[36px] w-[140px]">
            <SelectValue placeholder="Select type" />
          </SelectTrigger>
          <SelectContent className="w-[var(--radix-select-trigger-width)]">
            <SelectItem value="public">Public Image</SelectItem>
            <SelectItem value="private">Private Image</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="w-full rounded border border-border">
        <div className="flex flex-col gap-4 p-4">
          <TextField
            name="containerImage"
            label="Container Image"
            required
            baseHOCClassName="pb-0"
            placeholder="Image Reference: (e.g) myorg/myimage:latest"
            validate={(value) => {
              return (
                required(value) ||
                validateContainerImageMetachar(value) ||
                validateContainerImage(value)
              );
            }}
            onBlur={() => containerVerticalFlowAnalytics.trackContainerImageFilled()}
          />
          {values.isPrivate && (
            <>
              <TextField
                name="username"
                label="Private Registry Credentials"
                placeholder="User Name"
                baseHOCClassName="pb-0"
                validate={required}
                onBlur={() => containerVerticalFlowAnalytics.trackPrivateRegistryUsernameFilled()}
              />
              <TextField
                type="password"
                name="secret"
                baseHOCClassName="pb-0"
                label="Password or Token"
                placeholder="****"
                validate={required}
                onBlur={() => containerVerticalFlowAnalytics.trackPrivateRegistryPasswordFilled()}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};
